<template>
  <div class="container-upload">
    <div
      class="imagen-row"
      v-if="showPreview.show"
    >
      <q-img
        class="centrado rounded-borders"
        :src="previewImage === null ? require(`@/assets/${imgDefault}`) : previewImage"
        :ratio="showPreview.ratio"
        :style="{
          width: showPreview.sizes.width,
          height: showPreview.sizes.height,
        }"
      >
        <template v-slot:error>
          <div class="absolute-full flex flex-center error-img">
            <q-img
              :src="require('@/assets/img/iconfinder-icon-image.png')"
              width="50%"
            />
          </div>
        </template>
      </q-img>
    </div>
    <div class="upload-row">
      <q-file
        data-cy="file-input"
        :accept="config.accept"
        standout
        dense
        v-model="img"
        :display-value="labelFile"
        max-files="1"
        :multiple="false"
        @input="getImage"
        class="bSecondary"
        input-class="inputClass"
      >
        <template v-slot:prepend>
          <q-icon
            class='upload-icon2'
            :name="'img:' + require('@/assets/img/upload-icon.svg')"
          />
        </template>
      </q-file>
    </div>
    <div v-if="botonDelete" class="delete-row">
      <q-btn
        unelevated
        @click="deleteImg()"
        class='bSecondary col-12'
        icon="delete"
        :label="labelBorrar"
        />
    </div>
  </div>
</template>
<script>
import Formats from '@/components/shared/mixins/Formats.js';
import { QImg } from 'quasar';

export default {
  components: { QImg },
  mixins: [Formats],
  props: {
    imgDefault: {
      type: String,
      default: function () {
        return 'img/iconfinder-icon-image.png';
      }
    },
    botonDelete: {
      type: Boolean,
      default: () => false
    },
    // imgFile: File,
    label: String,
    labelBorrar: String,
    value: {
      required: true
    },
    showPreview: {
      type: Object,
      default: function () {
        return {
          show: false,
          sizes: {
            width: null,
            height: null
          },
          ratio: ''
        };
      }
    }
  },
  data () {
    return {
      img: typeof this.value === 'string' ? null : this.value,
      labelFile: this.label,
      previewImage: null,
      config: {
        accept: 'image/*'
      }
    };
  },
  methods: {
    async getImage () {
      this.$emit('input', this.img);
    },
    async setPreview () {
      this.previewImage = await this.getBase64(this.img);
    },
    deleteImg () {
      this.$emit('deleteImg');
    }
  },
  watch: {
    value: {
      handler: function () {
        this.img = typeof this.value === 'string' ? null : this.value;
        if (this.img !== null) {
          this.setPreview();
        } else {
          this.previewImage = this.value;
        }
      },
      immediate: true
    },
    label: {
      handler: function () {
        this.labelFile = this.label;
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/style.scss";
.q-img {
  border-radius: 50%;
}
.container-upload{
  padding: 0px !important;
}
.imagen-row{
  padding-top: 0px !important;
  margin: 0px !important;
}
.upload-row, .delete-row, .imagen-row{
  display: flex;
  justify-content: center;
}
.delete-row {
  margin-bottom: 30px;
}
.q-btn {
  margin-left: 0px !important;
  height: 40px;
  width: auto;
  padding-top: 4px;
  font-size: 11px;
  width: 75%;
}
::v-deep {
  .inputClass {
    font-size: 11px !important;
  }
  .q-icon {
    font-size: 14px !important;
  }
  .q-field {
    width: 75%;
  }
  .q-img{
    margin: 0px !important;
  }
}

</style>
